// extracted by mini-css-extract-plugin
export var container = "SupplierSelect-module--container--V4PMV";
export var supplierItem = "SupplierSelect-module--supplierItem--1CNvt";